module.exports = "static/assets/7d2d28d80d4ae06acb4fdbde429448e6.svg";